export var IDistribution;
(function (IDistribution) {
    IDistribution["BOX"] = "BOX";
    IDistribution["SPHERE"] = "SPHERE";
    IDistribution["DISC"] = "DISC";
    IDistribution["LINE"] = "LINE";
})(IDistribution || (IDistribution = {}));
